module.exports = __webpack_public_path__ + "assets/img/detail3.8cd360b7.png";